module.exports = __webpack_public_path__ + "img/ctg-online.2f16960d.svg";